import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { ResidentialListRequestBody, ResidentialListResponse } from "./types";

export class ResidentialListAPI extends BaseAPI<
  ResidentialListRequestBody,
  ResidentialListResponse
> {
    protected route = ApiRoutes.property.residential;
    protected method = RequestMethod.GET;
    // No params array - all parameters should be query parameters
} 